import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import {
  getFirestore,
  collection,
  getDocs,
  doc,
  updateDoc,
  addDoc,
  setDoc, // ✅ Needed for specific document IDs
  getDoc
} from "firebase/firestore";
import { OAuthProvider } from "firebase/auth";
import { serverTimestamp } from "firebase/firestore"; // Add to your existing import block



// 🔹 Your Firebase Config
// Uses environment variables if available, falls back to hardcoded values for backward compatibility
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBD-up6BrhgpvjHaUlYQjhhWrFCyuhFo_8",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "gutenstack.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "gutenstack",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "gutenstack.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "497877158788",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:497877158788:web:6b1cd77165f87b67f32bd1",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-2WRVWK9TV1"
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export const db = getFirestore(app);
export const appleProvider = new OAuthProvider("apple.com");

// Analytics and Storage load on first use so the initial route does not
// initialize them (or pull their SDKs into the main bundle).
let analyticsBundle = null;
export function logAnalyticsEvent(eventName, eventParams) {
  if (typeof window === "undefined") return;
  if (!analyticsBundle) {
    analyticsBundle = import("firebase/analytics")
      .then(({ getAnalytics, logEvent }) => ({ analytics: getAnalytics(app), logEvent }))
      .catch((error) => {
        analyticsBundle = null;
        console.warn("Analytics init failed:", error);
        return null;
      });
  }
  analyticsBundle.then((loaded) => {
    if (loaded) loaded.logEvent(loaded.analytics, eventName, eventParams);
  }).catch((error) => {
    console.warn("Analytics tracking error:", error);
  });
}

let storagePromise = null;
export function getAppStorage() {
  if (!storagePromise) {
    storagePromise = import("firebase/storage").then(({ getStorage }) => getStorage(app));
  }
  return storagePromise;
}

// ✅ Firestore Functions

// 🔹 Add or update user profile in Firestore
export const saveUserProfile = async (user) => {
  if (!user) return;
  
  const userRef = doc(db, "users", user.uid);
  const userData = {
    displayName: user.displayName || "",
    profilePic: user.photoURL || "",
    createdAt: new Date(),
  };

  try {
    await setDoc(userRef, userData, { merge: true }); // ✅ Merge to avoid overwriting
    if (user.email) {
      await setDoc(doc(db, "users", user.uid, "private", "contact"), { email: user.email }, { merge: true });
    }
  } catch (error) {
    console.error("Error saving user profile:", error);
  }
};

// 🔹 Add a book to a user's library
export const addBookToUserLibrary = async (userId, bookData) => {
  if (!userId || !bookData.title) return;

  const bookRef = doc(db, "users", userId, "books", bookData.title); // ✅ Nest under user

  try {
    await setDoc(bookRef, bookData);
    console.log("Book successfully added!");
  } catch (error) {
    console.error("Error adding book:", error);
  }
};


// 🔹 Fetch books for a user
export const getUserBooks = async (userId) => {
  if (!userId) return [];

  const booksCollection = collection(db, "users", userId, "books");
  try {
    const booksSnapshot = await getDocs(booksCollection);
    return booksSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    console.error("Error fetching books:", error);
    return [];
  }
};

export const postToFeed = async (entry) => {
  try {
    const feedRef = collection(db, "feed");

    const post = {
      ...entry,
      timestamp: serverTimestamp(),
    };

    await addDoc(feedRef, post);
    console.log("📝 Logged to feed:", post);
  } catch (err) {
    console.error("❌ Failed to post to feed:", err);
  }
};



// ✅ Export Firestore functions
export { collection, getDocs, doc, updateDoc, addDoc, setDoc, getDoc,  };